import React from 'react'
import { type IScheduleDateFiledUIProps, ScheduleDateFiledUI } from './ui/ScheduleDateFiledUI'
import { ScheduleDateFiledContext } from './context/sendLaterContext'
import { type ScheduleDateFiledStore } from './store/ScheduleDateFiledStore'

type ISendLaterProps = {
  store: ScheduleDateFiledStore
} & IScheduleDateFiledUIProps

export const ScheduleDateFiled = ({ store, ...props }: ISendLaterProps) => {
  return (
    <ScheduleDateFiledContext.Provider value={store}>
      <ScheduleDateFiledUI {...props} />
    </ScheduleDateFiledContext.Provider>
  )
}
